/* eslint-disable no-restricted-imports */
import { useTranslate } from '@im/react-localization';
import { Dialog } from '@im/ui-lib/zenith/Dialog';
import { Box, Typography, styled } from '@mui/material';
import React from 'react';

type Props = {
  mutuallyExclPopup?: boolean;
  setMutuallyExclPopup?: React.Dispatch<React.SetStateAction<boolean>>;
  validationResult?: string;
};
export default function ValidationPopup(props: Props) {
  const translate = useTranslate();
  const { mutuallyExclPopup, setMutuallyExclPopup, validationResult } = props;

  const handlePrimaryButtonClick = () => {
    if (setMutuallyExclPopup) {
      setMutuallyExclPopup(false);
    }
  };

  return (
    <Dialog
      backgroundBlur
      backgroundType="default"
      checkbox={false}
      dialogFooterType="horizontal-right-aligned"
      dialogHeaderText={translate('CMP.CartValidationTitle')}
      handleClose={handlePrimaryButtonClick}
      headerPaddingBottom
      helpIcon={false}
      minHeight="300px"
      onPrimaryButtonClick={handlePrimaryButtonClick}
      open={mutuallyExclPopup}
      padding
      primaryButtonProps={{
        id: 'PopupContinue',
        sx: { backgroundColor: '#1570EF', outline: 'none' },
      }}
      primaryButtonText={'Got it'}
      secondaryButtonProps={{ id: 'PopupCancel', sx: { display: 'none' } }}
      showCloseButton={true}
      showDialogFooter
      type="horizontal-left-aligned"
    >
      <StyledBox>
        <Typography variant="text-sm-regular">{validationResult}</Typography>
      </StyledBox>
    </Dialog>
  );
}

const StyledBox = styled(Box)(() => ({ paddingTop: '24px' }));
